export const UPDATE_MODE = 'UPDATE_MODE'
export const REFRESH_CONFIG = 'REFRESH_CONFIG'
export const SET_NETWORK_AVAILABLE = 'SET_NETWORK_AVAILABLE'
export const GET_CONFIG_REQUESTED = 'GET_CONFIG_REQUESTED'
export const SHOULD_WAIT_FOR_REDIRECT = 'SHOULD_WAIT_FOR_REDIRECT'
export const ENABLE_BACKBAR_MODE = 'ENABLE_BACKBAR_MODE'
export const DISABLE_BACKBAR_MODE = 'DISABLE_BACKBAR_MODE'
export const ENABLE_KIOSK_BARCODE_SCANNING = 'ENABLE_KIOSK_BARCODE_SCANNING'
export const DISABLE_KIOSK_BARCODE_SCANNING = 'DISABLE_KIOSK_BARCODE_SCANNING'
export const SET_RECEIPT_SETTINGS = 'SET_RECEIPT_SETTINGS'
export const SET_BARCODE_SCANNING_SETTINGS = 'SET_BARCODE_SCANNING_SETTINGS'
export const RESTART_BARCODE_SCANNER = 'RESTART_BARCODE_SCANNER'

export const updateMode = (mode = 'concession') => ({
  type: UPDATE_MODE,
  payload: { mode },
})

export const refreshConfig = () => ({
  type: REFRESH_CONFIG,
})

export const setNetworkAvailable = (payload) => ({
  type: SET_NETWORK_AVAILABLE,
  payload,
})

export const shouldWaitForRedirect = (payload) => ({
  type: SHOULD_WAIT_FOR_REDIRECT,
  payload,
})

export const setReceiptSettings = (payload) => ({
  type: SET_RECEIPT_SETTINGS,
  payload,
})

export const setBarcodeScanningSettings = (payload) => ({
  type: SET_BARCODE_SCANNING_SETTINGS,
  payload,
})

// the barcode scanner needs to be 'restarted' since the scanner is used
// across multiple screens with different functionality.
// @param {boolean}
export const restartBarcodeScanner = (payload) => ({
  type: RESTART_BARCODE_SCANNER,
  payload,
})

/**
 * @deprecated this is calling an unwatched "loadConfig.type" action
 * we are using '@ordernext/networking-stadium/stadium/loadConfig`
 */
export function loadConfig(payload) {
  return {
    type: GET_CONFIG_REQUESTED,
    payload,
  }
}

/**
 * @deprecated this is not used we are using '@ordernext/networking-stadium/stadium/loadConfig`
 */
loadConfig.type = GET_CONFIG_REQUESTED

export const enableBackbarMode = () => ({
  type: ENABLE_BACKBAR_MODE,
})

export const disableBackbarMode = () => ({
  type: DISABLE_BACKBAR_MODE,
})

export const enableKioskBarcodeScanning = () => ({
  type: ENABLE_KIOSK_BARCODE_SCANNING,
})

export const disableKioskBarcodeScanning = () => ({
  type: DISABLE_KIOSK_BARCODE_SCANNING,
})
